import { Component, Input } from '@angular/core';
import { Trailers, Orders } from '../../interfaces';
import { MessageService } from 'primeng/api';
import { DataServiceService } from '../../services/data-service.service';

@Component({
  selector: 'app-salt-type-dialog',
  templateUrl: './salt-type-dialog.component.html',
  styleUrl: './salt-type-dialog.component.scss'
})
export class SaltTypeDialogComponent {

  constructor(private messageService: MessageService, private dataServiceService: DataServiceService) {}

  @Input() trailers: Trailers[] = [];
  @Input() allOrders: Orders[] = [];
  
  showSaltTypeDialog: boolean = false;
  selectedOrder: Orders | null = null;
  pendingCallback: (() => void) | null = null;

  selectedSaltType: string = '';
  saltTypeOptions = [
    { label: 'Sea Salt', value: 'Sea Salt' },
    { label: 'Higrade', value: 'Higrade' }
  ];

  // Self-contained method to check if salt dialog is needed and handle the flow
  checkAndHandleSaltTrailer(order: Orders, callback: () => void) {
    const trailer = this.trailers.find(t => t.trailer_id === order.trailer_id);
    
    // Check if it's a salt trailer (has SALT in setup)
    if (trailer && trailer.setup?.toUpperCase().includes('SALT')) {
      // Store the order and callback, then show dialog
      this.selectedOrder = order;
      this.pendingCallback = callback;
      this.showSaltTypeDialog = true;
    } else {
      // Not a salt trailer, proceed normally
      callback();
    }
  }

  confirmSaltType() {
    if (!this.selectedSaltType) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select a salt type.'
      });
      return;
    }
    
    // Update trailer status with selected salt type
    if (this.selectedOrder?.trailer_id) {
      this.dataServiceService.updateTrailer(this.selectedOrder.trailer_id, {
        status: this.selectedSaltType
      }).subscribe({
        next: () => {
          console.log(`Trailer ${this.selectedOrder?.trailer_id} status updated to ${this.selectedSaltType}`);
          // Execute the pending callback to continue with the original operation
          this.executePendingCallback();
        },
        error: (error) => {
          console.error('Failed to update trailer status:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update trailer status'
          });
        }
      });
    } else {
      // No trailer to update, just execute the callback
      this.executePendingCallback();
    }
  }

  cancelSaltType() {
    console.log('Salt type selection cancelled');
    this.resetDialog();
  }

  private executePendingCallback() {
    if (this.pendingCallback) {
      this.pendingCallback();
      this.pendingCallback = null;
    }
    this.resetDialog();
  }

  private resetDialog() {
    this.selectedSaltType = '';
    this.selectedOrder = null;
    this.pendingCallback = null;
    this.showSaltTypeDialog = false;
  }
}